import { Icon, RadioButton, Tooltip, Typography } from "@kyan/ui";
import { useEffect } from "react";

import { underlyingSymbols } from "#/config/markets";
import { PortfolioSymbol, type PortfolioSymbolType } from "#/types/markets";

interface MarketSelectorProps {
  onChange: (value: PortfolioSymbolType) => void;
  value: PortfolioSymbolType;
  title?: "market" | "portfolio";
  disabledMarket?: PortfolioSymbolType;
}

const markets = [
  ...underlyingSymbols.map((symbol) => ({
    label: (
      <div className="flex flex-col justify-center">
        <Typography className="leading-3">{symbol}</Typography>
        <Typography className="leading-3 font-normal">Portfolio</Typography>
      </div>
    ),
    id: symbol,
    className: "flex-1",
  })),
  {
    label: (
      <div className="flex flex-col justify-center">
        <Typography className="leading-3 font-normal">Unallocated</Typography>
        <Typography className="leading-3">USDC</Typography>
      </div>
    ),
    id: PortfolioSymbol.USDC,
    className: "flex-1",
  },
];

export const MarketSelector: React.FC<MarketSelectorProps> = ({
  onChange,
  value,
  title,
  disabledMarket,
}) => {
  useEffect(() => {
    if (disabledMarket && value === disabledMarket) {
      onChange(
        markets.find((market) => market.id !== disabledMarket)?.id ||
          PortfolioSymbol.USDC,
      );
    }
  }, [disabledMarket, onChange, value]);
  return (
    <>
      {title === "market" ? (
        <Typography size={12} className="mt-4 mb-1">
          Market
        </Typography>
      ) : (
        <Typography size={12} className="mt-4 mb-1 flex items-center gap-1">
          Portfolio
          <Tooltip content="Choose which portfolio to deposit collateral into. The margin requirements for each portfolio are calculated separately.">
            <Icon size="xs" name="question" className="text-textSecondary" />
          </Tooltip>
        </Typography>
      )}
      <RadioButton
        size="xl"
        value={value}
        className="mb-4"
        items={markets.map((market) => ({
          ...market,
          disabled: market.id === disabledMarket,
        }))}
        onChange={onChange}
      />
    </>
  );
};
